export const MOTION_EDITOR_PATH = '/motion-editor';
